import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NameAndAvatar, TagComponent, EditWithIcon, CustomDelete } from 'components';
import { Images, PermissionList, RolePermission, tagEnums, useModal } from 'utils';
import { resourceActions } from 'store';
import { AddResource } from './addResource';

const DELETE_RESOURCE = 'DELETE_RESOURCE';

export const SingleResourceHeader = ({}) => {
    const resourceById = useSelector((state) => state.resource.resourceById);
    const { open } = useModal();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const canManage = RolePermission([PermissionList.MANAGE_RESOURCE?.code]);

    const handleActions = (name) => {
        if (name === 'edit') {
            open(<AddResource info={resourceById} />);
        }
        if (name === 'delete') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this folder? This action is not reversible."
                    info="Delete Folder"
                    handleDel={() => dispatch(resourceActions.deleteResource(resourceById?.id))}
                    actionType={DELETE_RESOURCE}
                    innerText={'Delete'}
                    afterSuccess={() => {
                        navigate('/resource');
                    }}
                />
            );
        }
    };

    return (
        <Fragment>
            <div className="tabs-wrapper">
                <div className="full-width">
                    <div className="space-between-flex-start">
                        <NameAndAvatar
                            src={Images?.folderIcon}
                            name={resourceById?.name}
                            imageStyles={{ minWidth: 38, width: 38, height: 38 }}
                        >
                            <div className="flex-align-center" style={{ gap: 12 }}>
                                <TagComponent
                                    userInfo={resourceById}
                                    module={tagEnums.RESOURCE}
                                    singleView
                                    doNotCropTags
                                    maxTags={null}
                                    notSetText={'No tags added'}
                                />
                            </div>
                        </NameAndAvatar>
                        {canManage && (
                            <div className="flex-align-center" style={{ gap: 16 }}>
                                <EditWithIcon handleClick={() => handleActions('edit')} />
                                <EditWithIcon handleClick={() => handleActions('delete')} icon={Images.redTrash} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
